/** Ord-sprint: shuffle, seed, helpers. */

export function shuffleWords(words: string[], seed?: number): string[] {
  const arr = [...words];
  let s = seed ?? Date.now();
  const rand = () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 0x100000000;
  };
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export const SPRINT_DURATION_MS = 60_000;
